import styled from 'styled-components';
import spacing from '../../../theme/shared/spacing';
var Wrapper = styled.div.withConfig({
  displayName: "ShareButtonstyle__Wrapper",
  componentId: "sc-18d8mc8-0"
})(["display:flex;align-items:center;justify-content:center;"]);
var Copy = styled.p.withConfig({
  displayName: "ShareButtonstyle__Copy",
  componentId: "sc-18d8mc8-1"
})(["width:auto;margin:0 ", " 0 0;&:first-child{margin-bottom:0;}"], spacing('md'));
var ShareButtonList = styled.ul.withConfig({
  displayName: "ShareButtonstyle__ShareButtonList",
  componentId: "sc-18d8mc8-2"
})(["width:auto;margin:0;padding:0;list-style:none;"]);
var ShareButtonItem = styled.li.withConfig({
  displayName: "ShareButtonstyle__ShareButtonItem",
  componentId: "sc-18d8mc8-3"
})(["width:40px;height:40px;display:inline-block;margin:", ";"], spacing('sm'));
export { Wrapper, Copy, ShareButtonList, ShareButtonItem };